// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingIndicator_root__qEoxa","rotation":"LoadingIndicator_rotation__oFgre"};